module.exports = __webpack_public_path__ + "img/protocolo.bb8fa85f.png";